import React, { Component } from 'react';
import { PropTypes } from "Subschema";
import styles from "../labels/FloatingLabel.less";
import _isFunction from "lodash/Lang/isFunction";


export default class SsnNineTemplate extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
  }

  componentWillMount() {
    const {
      ssnNineDefaultHidden
    } = this.props;
    this.props.onSsnCheckChange(ssnNineDefaultHidden || true);
  }

  handleCheckboxChange = (e) => {
    this.props.onSsnCheckChange(e.target.checked);
  }

  render() {
    const {
      legend,
      content,
      legendClass,
      buttons,
      className,
      ssnNineDefaultHidden,
      ...rest
    } =  {...this.props.field, ...this.props};

    return legend ?
      (<fieldset className={className}>
          <legend className={legendClass}>
            {legend}
          </legend>
          {content}
          {this.props.children}
          {buttons}
      </fieldset>) :
      (<div className={`${className} ${styles.ssnNineContent}`}>
          {content}
        <div>
          <div className={`${styles.ssnNineChildren}`}>
            {this.props.children}
          </div>
          <div className={`${styles.ssnNine}`}>
            <input type="checkbox"
              name={this.props.path+'_internal.edit'}
              defaultChecked = {ssnNineDefaultHidden}
              onChange = {e => this.handleCheckboxChange(e)}/>
            <span>Hide</span>
          </div>
        </div>
        {buttons}
      </div>)
  }
}



SsnNineTemplate.propTypes = {
  buttons: PropTypes.node,
  legend: PropTypes.node,
  className: PropTypes.cssClass,
  field: PropTypes.any,
  content: PropTypes.node,
  ssnNineDefaultHidden: PropTypes.bool,
  onSsnCheckChange: PropTypes.valueEvent,
  ssnChecked: PropTypes.value
};


SsnNineTemplate.defaultProps = {
  onSsnCheckChange: "_internal.ssnChecked",
  ssnChecked: "_internal.ssnChecked"
};



/** WEBPACK FOOTER **
 ** ./src/templates/SsnNineTemplate.jsx
 **/